import { angularInjectorProvider } from 'Injector';
import { type FrontRoyalRootScope } from 'FrontRoyalAngular';
import { type AnyObject } from '@Types';

export const pushUpdatedPropertiesOntoCurrentUserIguanaObject = (
    updatedProperties: AnyObject,
    forceApply: boolean = false,
) => {
    const $injector = angularInjectorProvider.requireInjector();
    const $rootScope = $injector.get<FrontRoyalRootScope>('$rootScope');
    const currentUser = $rootScope.currentUser;

    // We use copyAttrs so that iguana will instantiate embedded objects
    currentUser?.copyAttrs(updatedProperties);

    if (forceApply) {
        $rootScope.$applyAsync();
    }

    return currentUser;
};
